import { useEffect, useState } from "react";
import { Percent } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Panel, Loading } from "../State";

export const FeeSettings = ({ address }) => {
  const [s, setS] = useState(null);
  const [wallet, setWallet] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/token-page/${address}/fees`).then((r) => { setS(r.data); setWallet(r.data.payout_wallet || ""); }).catch(() => {}); }, [address]);
  const save = async (patch) => {
    const w = wallet.trim();
    if (w && !/^0x[0-9a-fA-F]{40}$/.test(w)) return toast.error("Enter a valid 0x wallet address");
    setBusy(true);
    try { const { data } = await api.put(`/token-page/${address}/fees`, { payout_wallet: w || null, fee_enabled: s.fee_enabled, ...patch }); setS(data); toast.success("Fee settings saved"); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Panel title="Swap fee & project earnings" icon={Percent} testid="fee-settings-panel">
      {!s ? <Loading /> : (
        <div className="p-5 space-y-4 text-sm">
          <p className="text-slate-300" data-testid="fee-settings-summary">Swap fee <b className="text-white">{s.fee_enabled ? `${s.total_bips / 100}%` : "off"}</b>{s.fee_enabled && <> · project share <b className="text-lime">{(s.total_bips * s.project_share_pct) / 10000}%</b> · HIVEVORA {(s.total_bips * (100 - s.project_share_pct)) / 10000}%</>}</p>
          <p className="text-[11px] text-slate-500" data-testid="fee-settings-disclosure">{s.applies_to}</p>
          <label className="block space-y-1.5">
            <span className="text-xs text-slate-400">Wallet that receives the project share (leave empty to use the creator wallet). Use it for treasury, buybacks, airdrops or competition prizes.</span>
            <input data-testid="fee-payout-wallet" value={wallet} onChange={(e) => setWallet(e.target.value)} placeholder="0x…" className="w-full rounded-lg border border-white/10 bg-black/40 px-3 py-2 font-mono text-xs text-white outline-none focus:border-lime/60" />
          </label>
          <div className="flex flex-wrap gap-2">
            <button data-testid="fee-settings-save" disabled={busy} onClick={() => save({})} className="btn-lime px-4 py-2 text-xs disabled:opacity-40">Save payout wallet</button>
            {s.can_opt_out && <button data-testid="fee-optout-toggle" disabled={busy} onClick={() => save({ fee_enabled: !s.fee_enabled })} className="rounded-lg border border-white/15 px-3 py-2 text-xs text-slate-300 hover:text-lime">{s.fee_enabled ? "Opt out of the swap fee" : "Opt in to the swap fee"}</button>}
          </div>
          {s.launched && <p className="text-[11px] text-slate-500">Tokens launched on HIVEVORA always use the disclosed fee.</p>}
        </div>
      )}
    </Panel>
  );
};
